import KendoHierarchicalDataSourceMixin from './KendoHierarchicalDataSourceMixin'

export default {
    name: 'kendo-hierarchicaldatasource',
    mixins: [ KendoHierarchicalDataSourceMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoHierarchicalDataSource/index.js